module.exports = __webpack_public_path__ + "img/comm-server.009d5682.svg";